var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{class:{ 'responsive-container': !_vm.fluid, 'pa-0': !_vm.withDefaultPadding, 'pa-1': _vm.withDefaultPadding, 'fill-height': _vm.fillHeight, 'h-100': !_vm.fillHeight },attrs:{"fluid":_vm.fluid}},[_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }